module.exports = __webpack_public_path__ + "static/img/1.086c3a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/1.png
// module id = W2+H
// module chunks = 0